import React from "react";
import { RouteComponentProps, withRouter } from "react-router";

import { ToolbarContext } from "./ToolbarMenu";

interface IToolbarSourceState {
    children: any;
}

class ToolbarSource extends React.Component<RouteComponentProps<any>, IToolbarSourceState> {
    constructor(props: Readonly<RouteComponentProps<any>>) {
        super(props);

        this.state = {
            children: null
        };

        this.update = this.update.bind(this);
    }

    public render() {
        return (
            <ToolbarContext.Provider value={{ children: this.state.children, updateChildren: this.update }}>
                {this.props.children}
            </ToolbarContext.Provider>
        );
    }

    private update(children: any) {
        this.setState({
            children
        });
    }
}

export default withRouter(ToolbarSource);
